import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useForm } from "react-hook-form";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import MetaTags from "react-meta-tags";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ReactHtmlParser from "react-html-parser";
import { FilePond, registerPlugin } from "react-filepond";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import FilePondPluginFileRename from "filepond-plugin-file-rename";
import ReactS3 from "react-s3";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { getCareerSlug } from "../../action/career";
import { postApplicantToAdmin, sendEmailApplicant } from "../../action/mailing";
import "filepond/dist/filepond.min.css";

var randomstring = require("randomstring");

registerPlugin(
  FilePondPluginFileValidateSize,
  FilePondPluginFileValidateType,
  FilePondPluginFileRename
);

const config = {
  bucketName: "ur-hub",
  dirName: "assets/applicant",
  region: "us-west-2",
  accessKeyId: "AKIAI2XCN446J7DEJMNA",
  secretAccessKey: "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",
};

const initialFileState = {
  file: [{ name: "" }],
};

export default function CareerSlug() {
  const [dataCareer, setDataCareer] = useState({});
  const [nama, setNama] = useState("");
  const [email, setEmail] = useState("");
  const [noTlp, setNoTlp] = useState("");
  const [perusahaan, setPerusahaan] = useState("");
  const [active, setActive] = useState(true);
  const { register, handleSubmit, errors, setError, clearError } = useForm();
  const [filesCV, setFilesCV] = useState(initialFileState);
  const [filesCL, setFilesCL] = useState(initialFileState);
  const [namaActive, setNamaActive] = useState(true);
  const [emailActive, setEmailActive] = useState(true);
  const [noActive, setNoActive] = useState(true);

  const [open, setOpen] = useState(false);
  const [openTime, setOpenTime] = useState(false);

  const location = useLocation();
  const slug = location.pathname.slice(7);

  useEffect(() => {
    getCareerSlug(slug).then((result) => {
      if (result && result.success === 1 && result.careers) {
        setDataCareer(result.careers);
      }
    });
  }, [slug]);

  const handleClose = () => {
    setOpen(false);
  };
  const handleCloseTime = () => {
    setOpenTime(false);
  };

  const onSubmit = (data, e) => {
    var formData = new FormData();
    formData.append("name", nama);
    formData.append("email", email);
    formData.append("phone", noTlp);
    formData.append("current_company", perusahaan);
    formData.append("cv", filesCV.file[0].name);
    formData.append("cover_letter", filesCL.file[0].name);
    formData.append("career_id", dataCareer.id);
    formData.append("career_title", dataCareer.title);
    formData.append("career_category", dataCareer.categories);

    setOpenTime(true);

    postApplicantToAdmin(formData).then((result) => {
      if (result && result.success === 1) {
        setOpenTime(false);

        if (filesCL.file[0] && filesCL.file[0].name) {
          ReactS3.uploadFile(filesCL.file[0], config).catch((err) => {});
        }
        if (filesCV.file[0] && filesCV.file[0].name) {
          ReactS3.uploadFile(filesCV.file[0], config).catch((err) => {});
        }

        sendEmailApplicant(formData).then(() => {
          setOpen(true);
        });
      } else {
        alert(result ? result.msg : "Terjadi kesalahan saat mengirim lamaran");
        setOpenTime(false);
      }
    });

    e.target.reset();
    setNamaActive(true);
    setNoActive(true);
    setEmailActive(true);
    setActive(true);
  };

  const handleEnableButton = (nActive, eActive, noAct) => {
    if (!nActive && !eActive && !noAct) {
      setActive(false);
    } else {
      setActive(true);
    }
  };

  return (
    <div style={{ maxWidth: "100%", overflowX: "hidden", backgroundColor: "#ffffff" }}>
      <MetaTags>
        <title>
          {dataCareer.title ? `${dataCareer.title} | Karir UR` : "Karir di UR"}
        </title>
      </MetaTags>

      {/* Header */}
      <section
        style={{
          paddingTop: "130px",
          paddingBottom: "36px",
          backgroundColor: "#f8fafc",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <Container maxWidth="lg">
          <Link
            to="/karir"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              color: "#DE148C",
              textDecoration: "none",
              fontWeight: 600,
              fontSize: "14px",
              marginBottom: "14px",
            }}
          >
            <ArrowBackIcon fontSize="small" /> Kembali ke Semua Posisi
          </Link>

          <Typography
            variant="h1"
            style={{
              fontWeight: 800,
              fontSize: "clamp(1.8rem, 3.5vw, 2.5rem)",
              color: "#0f172a",
              letterSpacing: "-0.02em",
              marginBottom: "10px",
            }}
          >
            {dataCareer.title || "Loading..."}
          </Typography>

          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
            <span
              style={{
                fontSize: "13px",
                fontWeight: 500,
                color: "#64748b",
              }}
            >
              Bandung, Indonesia • Full-time
            </span>
          </div>
        </Container>
      </section>

      {/* Details & Form Section */}
      <section style={{ padding: "48px 0 80px 0" }}>
        <Container maxWidth="lg">
          <Grid container spacing={5}>
            {/* Left: Job Details */}
            <Grid item xs={12} md={7}>
              <div
                style={{
                  backgroundColor: "#ffffff",
                  borderRadius: "16px",
                  padding: "32px",
                  border: "1px solid #e2e8f0",
                  marginBottom: "24px",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    color: "#0f172a",
                    marginBottom: "14px",
                  }}
                >
                  Deskripsi Pekerjaan
                </Typography>
                <div style={{ color: "#475569", lineHeight: 1.8, fontSize: "14px" }}>
                  {ReactHtmlParser(dataCareer.description || "Memuat deskripsi...")}
                </div>

                <div style={{ margin: "28px 0", borderTop: "1px solid #f1f5f9" }} />

                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    color: "#0f172a",
                    marginBottom: "14px",
                  }}
                >
                  Persyaratan &amp; Kualifikasi
                </Typography>
                <div style={{ color: "#475569", lineHeight: 1.8, fontSize: "14px" }}>
                  {ReactHtmlParser(dataCareer.requirement || "Memuat persyaratan...")}
                </div>
              </div>
            </Grid>

            {/* Right: Application Submission Form */}
            <Grid item xs={12} md={5}>
              <div
                style={{
                  backgroundColor: "#f8fafc",
                  borderRadius: "16px",
                  padding: "28px 24px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <Typography
                  variant="h4"
                  style={{
                    fontWeight: 700,
                    fontSize: "18px",
                    color: "#0f172a",
                    marginBottom: "6px",
                  }}
                >
                  Kirim Lamaran
                </Typography>
                <p style={{ color: "#64748b", fontSize: "13px", marginBottom: "20px" }}>
                  Lengkapi data diri dan lampirkan CV terbaru Anda.
                </p>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div style={{ marginBottom: "14px" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      inputRef={register({ required: "Nama wajib diisi" })}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val) {
                          clearError("name");
                          setNama(val);
                          setNamaActive(false);
                          handleEnableButton(false, emailActive, noActive);
                        } else {
                          setError("name", "required", "Nama wajib diisi");
                          setNamaActive(true);
                          handleEnableButton(false, emailActive, noActive);
                        }
                      }}
                      label="Nama Lengkap"
                      name="name"
                    />
                    {errors.name && (
                      <small style={{ color: "#ef4444", fontSize: "11px" }}>
                        {errors.name.message}
                      </small>
                    )}
                  </div>

                  <div style={{ marginBottom: "14px" }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={register({ required: "No. HP wajib diisi" })}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val) {
                          clearError("phone");
                          setNoTlp(val);
                          setNoActive(false);
                          handleEnableButton(namaActive, emailActive, false);
                        } else {
                          setError("phone", "required", "Nomor telepon wajib diisi");
                          setNoActive(true);
                          handleEnableButton(namaActive, emailActive, true);
                        }
                      }}
                      label="No. Telepon / WhatsApp"
                      name="phone"
                    />
                    {errors.phone && (
                      <small style={{ color: "#ef4444", fontSize: "11px" }}>
                        {errors.phone.message}
                      </small>
                    )}
                  </div>

                  <div style={{ marginBottom: "14px" }}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      size="small"
                      inputRef={register({ required: "Email wajib diisi" })}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
                          clearError("email");
                          setEmail(val);
                          setEmailActive(false);
                          handleEnableButton(namaActive, false, noActive);
                        } else {
                          setError("email", "required", "Format email tidak valid");
                          setEmailActive(true);
                          handleEnableButton(namaActive, true, noActive);
                        }
                      }}
                      label="Alamat Email"
                      name="email"
                    />
                    {errors.email && (
                      <small style={{ color: "#ef4444", fontSize: "11px" }}>
                        {errors.email.message}
                      </small>
                    )}
                  </div>

                  <div style={{ marginBottom: "16px" }}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      size="small"
                      onChange={(e) => setPerusahaan(e.target.value)}
                      label="Perusahaan Saat Ini (Opsional)"
                      name="perusahaan"
                    />
                  </div>

                  {/* CV Upload */}
                  <div style={{ marginBottom: "16px" }}>
                    <label style={{ fontSize: "13px", fontWeight: 600, color: "#334155", display: "block", marginBottom: "4px" }}>
                      Curriculum Vitae (PDF &lt; 500KB) *
                    </label>
                    <FilePond
                      allowReplace
                      checkValidity
                      maxFiles={1}
                      allowFileSizeValidation
                      allowFileTypeValidation
                      maxFileSize="500KB"
                      labelMaxFileSizeExceeded="Ukuran file terlalu besar"
                      acceptedFileTypes={[
                        "application/pdf",
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      ]}
                      required={true}
                      fileRenameFunction={(file) =>
                        `CV_${randomstring.generate()}${file.extension}`
                      }
                      onupdatefiles={(fileItems) => {
                        setFilesCV({
                          file: fileItems.map((f) => f.file),
                        });
                      }}
                    />
                  </div>

                  {/* Cover Letter Upload */}
                  <div style={{ marginBottom: "20px" }}>
                    <label style={{ fontSize: "13px", fontWeight: 600, color: "#334155", display: "block", marginBottom: "4px" }}>
                      Cover Letter / Portofolio (Opsional)
                    </label>
                    <FilePond
                      allowReplace
                      checkValidity
                      maxFiles={1}
                      allowFileSizeValidation
                      allowFileTypeValidation
                      maxFileSize="500KB"
                      acceptedFileTypes={[
                        "application/pdf",
                        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                      ]}
                      fileRenameFunction={(file) =>
                        `CL_${randomstring.generate()}${file.extension}`
                      }
                      onupdatefiles={(fileItems) => {
                        setFilesCL({
                          file: fileItems.map((f) => f.file),
                        });
                      }}
                    />
                  </div>

                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={active}
                    style={{
                      backgroundColor: active ? "#cbd5e1" : "#DE148C",
                      color: "#ffffff",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "10px",
                      borderRadius: "8px",
                      textTransform: "none",
                      boxShadow: "none",
                    }}
                  >
                    Kirim Lamaran
                  </Button>
                </form>
              </div>
            </Grid>
          </Grid>
        </Container>
      </section>

      {/* Progress Dialog */}
      <Dialog open={openTime} onClose={handleCloseTime}>
        <DialogTitle>Mengirim Lamaran</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Mohon menunggu sejenak, data lamaran Anda sedang dikirim...
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {/* Success Dialog */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Lamaran Berhasil Dikirim</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Terima kasih telah melamar posisi di UR. Tim talent acquisition kami akan segera meninjau profil Anda dan menghubungi via email.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Selesai
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
